module.exports = __webpack_public_path__ + "media/mahjongFlip.42065584.mp3";